var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.67871 5.89062H7.26172C7.80208 5.89062 8.26595 5.97201 8.65332 6.13477C9.04069 6.29753 9.33854 6.53841 9.54688 6.85742C9.75521 7.17643 9.85938 7.56868 9.85938 8.03418C9.85938 8.40202 9.79427 8.72103 9.66406 8.99121C9.53385 9.26139 9.34993 9.48763 9.1123 9.66992C8.87793 9.85221 8.60124 9.99544 8.28223 10.0996L7.8623 10.3145H5.58203L5.57227 9.25488H7.27637C7.55306 9.25488 7.78255 9.20605 7.96484 9.1084C8.14714 9.01074 8.28385 8.87565 8.375 8.70312C8.4694 8.5306 8.5166 8.33366 8.5166 8.1123C8.5166 7.87467 8.47103 7.6696 8.37988 7.49707C8.28874 7.32129 8.15039 7.1862 7.96484 7.0918C7.7793 6.9974 7.54492 6.9502 7.26172 6.9502H6.02148V13H4.67871V5.89062ZM8.69238 13L7.04688 9.81641L8.46777 9.81152L10.1328 12.9316V13H8.69238ZM12.2031 8.84473V13H10.9141V7.7168H12.125L12.2031 8.84473ZM11.998 10.168H11.6172C11.6204 9.78385 11.6725 9.43555 11.7734 9.12305C11.8743 8.81055 12.016 8.54199 12.1982 8.31738C12.3838 8.09277 12.6035 7.92025 12.8574 7.7998C13.1113 7.67936 13.3945 7.61914 13.707 7.61914C13.9609 7.61914 14.1904 7.65495 14.3955 7.72656C14.6006 7.79818 14.7764 7.91211 14.9229 8.06836C15.0726 8.22461 15.1865 8.42969 15.2646 8.68359C15.346 8.93424 15.3867 9.24349 15.3867 9.61133V13H14.0879V9.60156C14.0879 9.36068 14.0521 9.17025 13.9805 9.03027C13.9121 8.8903 13.8112 8.79102 13.6777 8.73242C13.5475 8.67383 13.3864 8.64453 13.1943 8.64453C12.9958 8.64453 12.8216 8.68522 12.6719 8.7666C12.5254 8.84473 12.4017 8.95378 12.3008 9.09375C12.2031 9.23372 12.1283 9.39486 12.0762 9.57715C12.0241 9.75944 11.998 9.95638 11.998 10.168Z",
    fill: "#BDBDBD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 1.5,
    stroke: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadon);
export default __webpack_public_path__ + "static/media/radon.fbf8bbf0ad0b23505f3671a213a24dbf.svg";
export { ForwardRef as ReactComponent };